import React, { useCallback, useRef } from 'react'
import { Grid } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { actionTemplates } from '../../../../api/coreData'
import EmptySection from '../../../atoms/EmptySection'
import Loading from '../../../molecules/Loading'
import SydButton from '../../../commonDesign/Button'
import FlexRow from '../../../molecules/FlexRow'
import MapActionDialog from './dialogs/MapActionDialog'
import ActionTemplateLink from './ActionTemplateLink'

const SEARCH_VALUE = {
  includes: {
    versionCount: true
  }
}

function CatalogActions () {
  const { data, isLoading } = actionTemplates.useSearchActionTemplates(SEARCH_VALUE)
  const mapActionRef = useRef(null)
  const onMapAction = useCallback(() => {
    mapActionRef.current.open()
  }, [])

  if (isLoading) {
    return (
      <FadeIn key='loading'>
        <Loading />
      </FadeIn>
    )
  }

  if (!(data?.total || 0)) {
    return (
      <FadeIn key='no_data'>
        <EmptySection title='No Action Templates' description='' />
        <FlexRow className='justify-center'>
          <SydButton
            variant='primary'
            size='md'
            icon='add'
            onClick={onMapAction}
          >
            Map an Action
          </SydButton>
        </FlexRow>
        <MapActionDialog ref={mapActionRef} />
      </FadeIn>
    )
  }

  return (
    <FadeIn key='actions'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FlexRow className='justify-end'>
            <SydButton
              variant='primary'
              size='md'
              icon='add'
              onClick={onMapAction}
            >
              Map an Action
            </SydButton>
            <MapActionDialog ref={mapActionRef} />
          </FlexRow>
        </Grid>
        <Grid item xs={12}>
          <FlexRow className='gap-sm flex-wrap'>
            {(data?.data || []).map(template => (
              <ActionTemplateLink key={template.code} template={template} />
            ))}
          </FlexRow>
        </Grid>
      </Grid>
    </FadeIn>
  )
}

export default CatalogActions
